import React, { useMemo, useState } from "react";
// import DropDown from "../../components/global/fields/DropDown";
import propTypes from "prop-types";
import OutsideClickHandler from "react-outside-click-handler";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import arrowDown from "../../../src/assets/icons/arrow-down.svg";
import { apirequest } from "../../API/api";
import { endpoint } from "../../API/config";
import ArrowUp from "../../assets/icons/arrow-up.svg";
import TablePagination from "../../components/table/TablePagination";
import useDebounce from "../../hooks/useDebounce";
import Loading from "../global/loader/Loading";
import TableByIcon from "../table/contentRepoTable/TableByIcon";

const ContentRepositoryComp = ({
  isforAddConentRepo,
  dataSource,
  contentRepoData,
  showAddAssetButton,
  selectedData,
  setSelectedData,
  setAssetData,
  contentRepoID,
}) => {
  const width = [
    { col: 1, width: "88%" },
    { col: 2, width: "20%" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [assetType, setAssetType] = useState([]);
  const [appliedAssetTypes, setAppliedAssetTypes] = useState([]);
  const [showDropdown, setShowDropDown] = useState(false);

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
  };

  const debouncedSearch = useDebounce(searchValue, 800);
  const dataPerPage = isforAddConentRepo ? 4 : 10;
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const paginate = (pageNumbers) => {
    setCurrentPage(pageNumbers);
  };

  const AssetType = [
    { id: 1, assetType: "Video" },
    { id: 2, assetType: "Assessment" },
    { id: 3, assetType: "Pdf" },
    { id: 4, assetType: "HTML" },
  ];

  const handleChange = (e, item) => {
    const isChecked = e.target.checked;
    // let value = e.target.value;
    if (isChecked) {
      // setPayload([...payload, e.target.id]);
      setAssetType([...assetType, item.assetType]);
    } else {
      setAssetType(assetType.filter((val) => val != item.assetType));
    }
  };

  const { data: assetResponse, isLoading } = useQuery(
    [
      endpoint.getAssetsUsingContentRepository.key,
      contentRepoID,
      debouncedSearch,
      appliedAssetTypes,
    ],
    () =>
      apirequest({
        url: endpoint.getAssetsUsingContentRepository.addr,
        method: "post",
        data: {
          contentRepositoryId: contentRepoID,
          searchKeyword: debouncedSearch,
          ...(appliedAssetTypes.length > 0 && { assetType: appliedAssetTypes }),
        },
      }),
    {
      enabled: !!contentRepoID,
      keepPreviousData: true,
      onSuccess: (res) => {
        setAssetData?.(res);
      },
      onError: (err) => alert(err.data.message),
    }
  );

  const displayData = useMemo(() => {
    if (contentRepoID) {
      return assetResponse?.data?.data ?? [];
    }
    return dataSource ?? [];
  }, [contentRepoID, assetResponse, dataSource]);

  const handleFilterSave = () => {
    setAppliedAssetTypes([...assetType]);
    setCurrentPage(1);
  };

  return (
    <>
      <div className="flex justify-between">
        {/* Added outside click handler for filter in Assets */}
        <OutsideClickHandler onOutsideClick={() => setShowDropDown(false)}>
          <div className="flex space-x-3">
            <div className="flex cursor-pointer bg-secondary-100 text-lg text-black shadow-outer px-[20px] py-[10px] rounded-xl items-center">
              Filter by:{" "}
              <input
                className="focus:outline-none  w-3/6 rounded-lg"
                placeholder={"Asset Type"}
                readOnly
                value={assetType.toString()}
              />
              <img
                src={arrowDown ? arrowDown : ArrowUp}
                onClick={() => setShowDropDown(!showDropdown)}
                className="ml-4"
              />
            </div>
            <p
              type="submit"
              className="bg-primary-200 text-white font-ibm px-12 rounded-xl hover:opacity-75 shadow-outer py-[10px] text-base font-medium mr-10 cursor-pointer"
              onClick={handleFilterSave}
            >
              Save
            </p>
          </div>

          {showDropdown && (
            <ul className="h-auto ml-2 mt-1 pt-2 px-3 w-80 border-2 border-solid border-gray-200 rounded-lg shadow-lg absolute z-50 bg-white overflow-y-scroll scrollbar scrollbar-thumb-secondary-700 scrollbar-thin scrollbar-thumb-rounded  max-h-[10rem]">
              {AssetType.map((item) => (
                <div className="flex" key={item.id}>
                  <input
                    type="checkbox"
                    id={item.id}
                    value={item.assetType}
                    checked={assetType.includes(item.assetType)}
                    onChange={(e) => handleChange(e, item)}
                  />
                  <li
                    key={item.id}
                    // removed onclick handler to avoid duplicated
                    // onClick={() => setAssetType([...assetType, item.assetType])}
                    className="font-ibm text-sm text-black font-medium opacity-60 py-1 cursor-pointer hover:bg-gray-200 px-4 capitalize"
                  >
                    {item.assetType}
                  </li>
                </div>
              ))}
            </ul>
          )}
        </OutsideClickHandler>
        <div className="flex">
          <input
            type="text"
            value={searchValue}
            onChange={handleSearch}
            placeholder="Search by Assets"
            className="w-96 border-2 border-secondary-300 rounded-2xl pl-4 pr-5 py-3 border-solid px-2 focus:outline-none placeholder-bold font-semibold text-xl focus:placeholder-transparent"
          />

          {!isforAddConentRepo && showAddAssetButton && (
            <div className="ml-4 flex">
              {/* <TableSearch  data = {dataSource}  setFilteredData={setFilteredData}/> */}
              <div className="ml-6 bg-primary-200 text-white font-normal px-6 rounded-xl hover:opacity-75 shadow-outer text-lg py-[7px] mr-5">
                <Link
                  className="text-white hover:text-white"
                  to={{
                    pathname: `/Courseware/ContentRepository/${localStorage.getItem(
                      "breadcrumbs"
                    )}/add-Asset`,
                    state: { contentRepoData },
                  }}
                >
                  Add Asset
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mr-6 min-h-[400px]">
        <div className="courseTable__table px-6 mx-5 shadow-outer w-[100%] rounded-xl bg-white py-5">
          {isLoading ? (
            <div className="flex items-center justify-center h-[400px]">
              <Loading />
            </div>
          ) : (
            <TableByIcon
              column={width}
              currentData={
                displayData != null
                  ? displayData?.slice(indexOfFirstItem, indexOfLastItem)
                  : displayData
              }
              isforAddConentRepo={isforAddConentRepo}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />
          )}
        </div>
      </div>
      {/* show pagination when required */}
      {displayData != null && displayData?.length > 0 && (
        <div className="courseTable__footer mx-auto mb-7">
          <TablePagination
            data={displayData}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            paginate={paginate}
            dataPerPage={dataPerPage}
          />
        </div>
      )}
    </>
  );
};
ContentRepositoryComp.propTypes = {
  isforAddConentRepo: propTypes.bool,
  dataSource: propTypes.array,
  contentRepoData: propTypes.any,
  showAddAssetButton: propTypes.bool,
  selectedData: propTypes.array,
  setSelectedData: propTypes.func,
  setAssetData: propTypes.func,
  contentRepoID: propTypes.string,
};

export default ContentRepositoryComp;
